module.exports = __webpack_public_path__ + "static/img/UZ.379f204b.png";